<template>
    <Dialog v-model="state" :scrollable="false" @close="$emit('close')">
        <div class="sending-popup" v-loading="loading">
            <h2 class="sending-popup__title">Рассылка пользователям</h2>

            <ModelSelect
                class="sending-popup__input"
                label="Выберите шаблон"
                item-value="type"
                item-text="name"
                :items="EMAIL_TEMPLATES"
                v-model="chosenTemplate"
            />

            <component
                v-if="templateComponent !== false"
                :is="templateComponent"
                @update-data="updateData"
                @update-valid="updateValid"
            />

            <div v-if="templateData && showConfirmButton" class="sending-popup__footer">
                <button
                    class="sending-popup__footer-button sending-popup__footer-button--cancel"
                    @click="$emit('close')"
                >
                    Отменить
                </button>

                <button class="sending-popup__footer-button" @click="submit">Отправить</button>
            </div>
        </div>
    </Dialog>
</template>

<script>
import Dialog from '@/components/UI/Dialog';
import UserSearchNotificationEmailReady
    from "@/components/user-search/notification/email-template/UserSearchNotificationEmailReady.vue";
import ModelSelect from '@/components/UI/models/ModelSelect';

const EMAIL_TEMPLATE = {
    DEFAULT: 'default',
    READY: 'ready',
};

const EMAIL_TEMPLATES = [
    {
        type: EMAIL_TEMPLATE.DEFAULT,
        name: 'Стандартный шаблон',
    },
    {
        type: EMAIL_TEMPLATE.READY,
        name: 'Готовый шаблон',
    },
];

export default {
    name: "UserSearchNotificationDialogEmailTemplate",

    components: {Dialog, ModelSelect, UserSearchNotificationEmailReady},

    emits: [ "close", "submit", "template" ],

    props: {
        loading: Boolean,
    },

    data: () => ({
        chosenTemplate: '',
        templateData: {},
        showConfirmButton: false,
        state: true,
    }),

    beforeMount() {
        this.clearData();
        this.state = true;
        this.showConfirmButton = false;
    },

    watch: {
        state(val) {
            if (!val && val !== this.show) {
                this.$emit("close");
            }
        },
        chosenTemplate(val) {
            this.clearData();
            this.showConfirmButton = false;
            this.$emit('template', val);
        },
    },

    computed: {
        EMAIL_TEMPLATES: () => EMAIL_TEMPLATES,

        templateComponent() {
            return {
                [EMAIL_TEMPLATE.READY]: UserSearchNotificationEmailReady,
            }[this.chosenTemplate] || false;
        },
    },

    methods: {
        clearData() {
            for (const k in this.templateData) {
                this.$set(this.templateData, k, undefined);
            }
        },
        submit() {
            this.$emit("submit", this.templateData, this.chosenTemplate);
        },
        updateData(templateData) {
            for (const k in templateData) {
                this.$set(this.templateData, k, templateData[k]);
            }
        },
        updateValid(val) {
            this.showConfirmButton = !!val;
        },
    },
};
</script>

<style scoped lang="scss">
@import '~@/styles/rem';
@import '~@/styles/variables';

.sending-popup {
    margin-bottom: urem(174);
    @include on-desktop {
        margin-bottom: urem(80);
        width: urem(700);
    }
    &__title {
        text-align: center;
        margin: urem(32) 0;
        @include set-font-size(18, 700, 24);
        @include on-desktop {
            @include set-font-size(26, 700, 31);
        }
    }

    &__input {
        margin-bottom: urem(36);
        @include on-desktop {
            margin-bottom: urem(56);
        }
    }

    &__attach-ready-button {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        padding: urem(14) urem(32);
        margin: urem(24) 0;
        background: $color-main-blue;
        border: none;
        border-radius: urem(10);
        text-align: center;
        color: #ffffff;
        @include set-font-size(14, 600, 20);
        @include on-desktop {
            width: auto;
            cursor: pointer;
        }
    }
    &__attach-ready-button-text {
        margin-right: urem(6);
    }

    &__attach-icon {
        width: urem(20);
        height: urem(20);
    }
    &__footer {
        @include on-desktop {
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: urem(307);
        }
    }
    &__footer-button {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        padding: urem(14) urem(32);
        margin: urem(24) 0;
        background: $color-main-blue;
        border: none;
        border-radius: urem(10);
        text-align: center;
        color: #ffffff;
        @include set-font-size(14, 600, 20);
        @include on-desktop {
            width: auto;
            cursor: pointer;
        }

        &--cancel {
            background: #fff;
            color: $color-main-blue;
            border: 1px solid $color-main-blue;
        }
    }
}
</style>
